import React, { useState, useMemo } from 'react';
import { Box } from '@material-ui/core';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import {
  // FormLabel,
  useTheme,
  TextField,
  InputAdornment,
  IconButton,
} from '@material-ui/core';
import { useIntl } from 'umi';
import { Controller, useFormContext } from 'react-hook-form';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import ModalML from '@/components/ModalML';
import CouponModal from '../operate_modal/coupon_modal/index';
import NumberFormatML from '@/components/NumberFormatML';
import InitPaginationML from '@/components/InitPaginationML';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import CampaignEquityStyled from './CampaignEquityStyled';

//数字问题
const NumberFormatCustom = React.forwardRef((props, ref) => (
  <NumberFormatML {...props} allowNegative={false} ref={ref} />
));
const CampaignEquity = (props) => {
  //过于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  //人群类型

  const { register } = useFormContext();
  const { control, setCouponList, couponList, status, type } = props;
  const [page, setPage] = useState({
    pageNum: 1,
    pageSize: 10,
  });
  const theme = useTheme();
  //打开优惠券模板
  const [open, setOpen] = useState();
  const handleCancel = () => {
    setOpen(false);
  };
  const onClose = () => {
    setOpen(false);
  };

  const handleSubmitSuccess = (selectList) => {
    setOpen(false);
    setCouponList(selectList);
  };
  //
  const handleSetting = () => {
    setOpen(true);
  };
  //删除优惠券
  const handleDeleteCouponItem = (id) => {
    if (status !== 'detail') {
      let selectedCouponList = [...couponList];
      let Index = -1;
      selectedCouponList.map((i, index) => {
        if (i.id === id) {
          Index = index;
        }
      });
      Index >= 0 && selectedCouponList.splice(Index, 1);
      setCouponList(selectedCouponList);
    }
  };
  // const { register } = useFormContext();

  const levelData =
    type === '发放优惠券'
      ? [
          {
            id: 0,
            name: '优惠券名称',
          },
          {
            id: 1,
            name: '优惠券内容',
          },
          {
            id: 2,
            name: '赠送数量',
          },
        ]
      : type === '优惠券有效期调整' || type === '优惠券失效调整'
      ? [
          {
            id: 0,
            name: '优惠券ID',
          },
          {
            id: 1,
            name: '优惠券名称',
          },
          {
            id: 2,
            name: '优惠券code',
          },
          {
            id: 3,
            name: '优惠券分类',
          },
          {
            id: 4,
            name: '获取来源',
          },
          {
            id: 5,
            name: '发放时间',
          },
          {
            id: 6,
            name: '有效期',
          },
          {
            id: 7,
            name: '优惠券状态',
          },
        ]
      : [
          {
            id: 0,
            name: formatMessage({ id: 'marketing.people.regnotcon.c02.lbl01' }),
          },
          {
            id: 1,
            name: formatMessage({ id: 'marketing.people.regnotcon.c02.lbl02' }),
          },
          {
            id: 2,
            name: formatMessage({ id: 'marketing.people.regnotcon.c02.lbl03' }),
          },
          {
            id: 3,
            name: formatMessage({ id: 'marketing.people.regnotcon.c02.lbl04' }),
          },
          {
            id: 4,
            name: formatMessage({ id: 'marketing.people.regnotcon.c02.lbl05' }),
          },
        ];
  const hasNext = useMemo(() => {
    const isHasNext =
      couponList.length < 11
        ? 1
        : couponList.length % ((page.pageNum - 1) * 10);
    return !(isHasNext > 0 && isHasNext < 10);
  }, [page.pageNum, couponList?.length]);

  const changePage = (data) => {
    setPage(data);
  };

  const dataList = useMemo(() => {
    const data = [...couponList];
    const pageData = data.splice((page.pageNum - 1) * 10, 10);
    return pageData || [];
  }, [page.pageNum, couponList?.length]);
  return (
    <CampaignEquityStyled theme={theme}>
      {status !== 'detail' && (
        <Box className="link" onClick={handleSetting}>
          {formatMessage({ id: 'marketing.people.regnotcon.n04.btn03' })}
        </Box>
      )}

      <Box mt={2}>
        <Box className="table">
          <Box
            className={
              type === '优惠券有效期调整' || type === '优惠券失效调整'
                ? 'table-title table-row-adjust-head'
                : 'table-title'
            }
          >
            {levelData &&
              levelData.map((title, i) => {
                return (
                  <div key={i} className={i === 1 && 'subTitle'}>
                    {title.name}
                  </div>
                );
              })}
          </Box>
          <Box className="table-content">
            {(() => {
              if (type === '发放优惠券') {
                return dataList?.map((item, index) => {
                  return (
                    <Box className="table-row" key={index}>
                      <div className="coupon-title">{item?.title}</div>
                      <div className="subTitle">{item?.subTitle}</div>
                      <div className="action">{item.givenNum} 张</div>
                    </Box>
                  );
                });
              }
              if (type === '优惠券有效期调整' || type === '优惠券失效调整') {
                return dataList?.map((item, index) => {
                  return (
                    <Box
                      className={
                        type === '优惠券有效期调整' || type === '优惠券失效调整'
                          ? 'table-row table-row-adjust'
                          : 'table-row'
                      }
                      key={index}
                    >
                      <div className="coupon-title">{item?.id}</div>
                      <div className="subTitle">{item?.title}</div>
                      <div className="action">{item.couponCode}</div>
                      <div className="coupon-title">{item?.type}</div>
                      <div className="subTitle">{item?.sourceType}</div>
                      <div className="action">{item.sendTime}</div>
                      <div className="subTitle">{item?.expirationTime}</div>
                      <div className="action">{item.status}</div>
                    </Box>
                  );
                });
              }
              if (couponList && couponList.length > 0) {
                return couponList?.map((item, index) => {
                  return (
                    <Box className="table-row" key={index}>
                      <div className="coupon-title">{item?.title}</div>
                      <div className="subTitle">{item?.subTitle}</div>
                      <div className="surplus">{item?.surplus}</div>
                      <div className="action">
                        <SvgIconML
                          name={'coupon'}
                          size={18}
                          className="coupon"
                        ></SvgIconML>
                        <span className="coupon-num">
                          <Controller
                            register={register}
                            name={`givenNum${index}`}
                            variant="standard"
                            type="number"
                            disabled={status === 'detail'}
                            K
                            // required
                            placeholder={''}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  张
                                </InputAdornment>
                              ),
                            }}
                            render={(rp) => (
                              <TextField
                                name={`givenNum${index}`}
                                variant="standard"
                                register={register}
                                disabled={status === 'detail'}
                                // type="number"
                                value={item.givenNum}
                                // required
                                placeholder={''}
                                InputProps={{
                                  inputComponent: NumberFormatCustom,
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      张
                                    </InputAdornment>
                                  ),
                                }}
                                onChange={(e) => {
                                  const currentCouponList = [];
                                  couponList.map((i) => {
                                    if (i.id === item.id) {
                                      i.givenNum = e.target.value;
                                      currentCouponList.push(i);
                                    } else {
                                      currentCouponList.push(i);
                                    }
                                    return currentCouponList;
                                  });
                                  setCouponList(currentCouponList);
                                  return rp.onChange(e.target.value);
                                }}
                              />
                            )}
                            control={control}
                            id="basic"
                            className="basic-name"
                            label={''}
                          />
                        </span>
                      </div>
                      <div className="delete">
                        <ButtonTip title="删除">
                          <IconButton
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            color="inherit"
                            disabled={status === 'detail'}
                            onClick={() => handleDeleteCouponItem(item.id)}
                          >
                            <DeleteForeverOutlinedIcon
                              style={{
                                fontSize: '20px',
                                color:
                                  status === 'detail'
                                    ? theme.palette.secondary.disabled
                                    : theme.palette.primary.main,
                              }}
                            />
                          </IconButton>
                        </ButtonTip>
                      </div>
                    </Box>
                  );
                });
              }
            })()}
          </Box>
        </Box>
        <Box mt={3}>
          <InitPaginationML
            hasNext={hasNext}
            page={page}
            total={couponList.length}
            changePages={changePage}
            showPagingDataStatus={true}
            pages={Math.ceil(couponList.length / 10)}
            showPageColor={true}
          />
        </Box>
      </Box>

      <ModalML
        open={open}
        setOpen={setOpen}
        onCancel={handleCancel}
        title={formatMessage({ id: 'marketing.people.regnotcon.d01.lbl02' })}
        onConfirm={handleSubmitSuccess}
        onClose={onClose}
      >
        <CouponModal
          open={open}
          control={control}
          setOpen={setOpen}
          onConfirm={handleSubmitSuccess}
          couponList={couponList}
        ></CouponModal>
      </ModalML>
    </CampaignEquityStyled>
  );
};
export default CampaignEquity;
